import { render } from "./UpdateProfile.view.vue?vue&type=template&id=25ab7fc5"
import script from "./UpdateProfile.view.vue?vue&type=script&lang=js"
export * from "./UpdateProfile.view.vue?vue&type=script&lang=js"

import "./UpdateProfile.view.vue?vue&type=style&index=0&id=25ab7fc5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__